import { PlayersManager } from "./PlayersManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

    export class Player extends Phaser.Sprite {

        public static STILL: string = "s";
        public static MOVING_VERTICALLY_1: string = "v1";
        public static MOVING_VERTICALLY_2: string = "v2";
        public static MOVING_HORIZONTALLY_1: string = "h1";
        public static MOVING_HORIZONTALLY_2: string = "h2";

        private static DELTA: number = 200;
        private static SPEED: number = 85;

        public hasReachedLimit: Function;

        public canBeHit: boolean;
        public shootBall_px: number;
        public shootBall_py: number;
        public rightPlayer: boolean;
        public playersManager: PlayersManager;
        public ball: any;
        public isOff: boolean;
        public hasReceived: boolean;
        public movementType: string;
        public textureSelected: string;
        public textureIdle: string;
        public textureIdleBlink: string;
        public textureAiming: string;
        public textureShooting: string;

        private returnToIdleTimeEvent: Phaser.TimerEvent;
        private movingVertically: boolean;
        private movingHorizontally: boolean;
        private lowerLimit: number;
        private upperLimit: number;
        private direction: number;
        private f: number;
        private blinking: boolean;

        // TODO hacer una variable scaleXFactor como en el elastic peg en lugar de
        // tener guardado en un booleano si es izquierdo o derecho

        constructor(game: Phaser.Game, x: number, y: number, key: string, rightPlayer: boolean, movementType: string) {

            super(game, x, y, key);

            this.canBeHit = false;
            this.ball = null;
            this.isOff = true;
            this.hasReceived = false;
            this.rightPlayer = rightPlayer;
            this.returnToIdleTimeEvent = null;
            this.movementType = movementType;
            this.f = 0;
            this.blinking = false;

            this.game.physics.p2.enable(this, GameConstants.SHOW_PHYSICS_BODIES);

            this.anchor.setTo(.5);

            this.body.allowGravity = false;
            this.body.allowRotation = true;
            this.body.setZeroVelocity();
            this.body.data.type = Phaser.Physics.P2.Body.KINEMATIC;
            this.body.setCircle(40);
            this.body.angularVelocity = 0;
            this.body.fixedRotation = false;
            this.body.setZeroDamping();

            let scaleX: number  = this.rightPlayer ? 1 : -1;
            this.scale.setTo(scaleX, 1);

            if (this.movementType !== Player.STILL) {
                this.setUpMovementVariables();
            }

            this.alpha = GameConstants.ALPHA_PHYSICS_BODIES;
        }

        public update(): void {

            super.update();

            if (this.blinking) {
                
                this.f ++;

                if (this.f === 6) {
                    this.returnToIdle();
                }
            }
        }

        public reverse(): void {

            this.direction = -this.direction;

            if (this.movingVertically) {
                this.body.velocity.y = this.direction * Player.SPEED;
            } else {
                this.body.velocity.x =  this.direction * Player.SPEED;
            }
        }

        public turnOn(): void {

            this.frameName = this.textureSelected;
            this.isOff = false;
        }

        public turnOff(): void {

            this.frameName = this.textureIdle;
            this.isOff = true;
        }

        public blink(): void {

            if ( this.ball !== null || GameVars.isBallAttachedToPassingMidfielder ) {
                return;
            }

            this.frameName = this.textureIdleBlink;

            this.f = 0;
            this.blinking = true;
        }

        public shootBall(): void {

            this.frameName = this.textureShooting;
            this.isOff = true;

            this.returnToIdleTimeEvent = this.game.time.events.add(200, this.returnToIdle, this);

            AudioManager.getInstance().playEffect("chuta_chutador");
        }

        public prepareToShoot(): void {

            if (this.returnToIdleTimeEvent !== null) {
                this.game.time.events.remove(this.returnToIdleTimeEvent);
            }

            this.hasReceived = true;
            this.frameName = this.textureAiming;
        }

        public stopMoving(): void {

            this.body.velocity.x = 0;
            this.body.velocity.y = 0;
        } 

        public returnToIdle(): void {

            this.blinking = false;

            if (this.hasReceived) {
                return;
            }

            this.frameName = this.textureIdle;
        }

        public getShootAngle(): number {
            // override
            return 90;
        }

        public onGamePaused(): void {
//            console.log("JUGADOR PAUSADO");
        }

        public onGameResumed(): void {
//            console.log("JUGADOR REANUDADO");
        }

        private setUpMovementVariables(): void {

            if (this.movementType === Player.MOVING_VERTICALLY_1) {

                this.movingVertically = true;
                this.movingHorizontally = false;

                this.lowerLimit = this.y;
                this.upperLimit = this.y + Player.DELTA;

                this.body.velocity.y = Player.SPEED;

                this.direction = 1;

            } else if (this.movementType === Player.MOVING_VERTICALLY_2) {

                this.movingVertically = true;
                this.movingHorizontally = false;

                this.lowerLimit = this.y - Player.DELTA;
                this.upperLimit = this.y ;

                this.body.velocity.y = -Player.SPEED;

                this.direction = -1;

            } else if (this.movementType === Player.MOVING_HORIZONTALLY_1) {

                this.movingVertically = false;
                this.movingHorizontally = true;

                this.lowerLimit = this.x;
                this.upperLimit = this.x + Player.DELTA;

                this.body.velocity.x = Player.SPEED;

                this.direction = 1;

            } else if (this.movementType === Player.MOVING_HORIZONTALLY_2) {

                this.movingVertically = false;
                this.movingHorizontally = true;

                this.lowerLimit = this.x - Player.DELTA;
                this.upperLimit = this.x ;

                this.body.velocity.x = - Player.SPEED;

                this.direction = -1;

            } else {
                this.movingVertically = false;
                this.movingHorizontally = false;
            }

            // definir la funcion hasReachedLimit para ahorrarnos un if con un booleano
            // ya que se llama en el bucle update
            if (this.movingVertically ) {

                this.hasReachedLimit = function(): boolean {
                    if (this.y < this.lowerLimit || this.y > this.upperLimit) {
                        return true;
                    } else {
                        return false;
                    }
                };

            } else if (this.movingHorizontally) {

                this.hasReachedLimit = function(): boolean {
                    if (this.x > this.upperLimit || this.x < this.lowerLimit) {
                        return true;
                    } else {
                        return false;
                    }
                };
            }
        }
    }
